export default __webpack_public_path__ + "static/media/regulatory--weight-limit--g3.19d1b90e.png";